import CustomFieldLabelPane from './CustomFieldLabelPane.vue';
import * as CustomFieldLabelController from './CustomFieldLabelController';

export default {
    CustomFieldLabelPane,
    ...CustomFieldLabelController,
};
